import { render, staticRenderFns } from "./AffectedAssetTableCell.vue?vue&type=template&id=96f74042"
import script from "./AffectedAssetTableCell.vue?vue&type=script&lang=js"
export * from "./AffectedAssetTableCell.vue?vue&type=script&lang=js"
import style0 from "./AffectedAssetTableCell.vue?vue&type=style&index=0&id=96f74042&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports